import React, { useContext } from "react";
import { MediaAuthContext } from "../../../../store/context/media-auth-context";
import { HeaderContext } from "../../../../store/context/header-context";
import { ANALYTICS_PROPS, URL_LABEL } from "../content/index.content";
import TrackedLink from "../../../Analytics/TrackedLink";
import "./index.scss";

const Auth = () => {
  const {
    auth: { isAuth },
  } = useContext(MediaAuthContext);
  const { t } = useContext(HeaderContext);
  const text = isAuth ? "Sign in" : "Sign up";
  return (
    <TrackedLink
      path={`/app/?${URL_LABEL}`}
      class="GCL-H-A"
      label={text}
      {...ANALYTICS_PROPS}
    >
      {t(text)}
    </TrackedLink>
  );
};

export default Auth;
